import { render, staticRenderFns } from "./KnFormSupplier.vue?vue&type=template&id=5af67d89&"
import script from "./KnFormSupplier.vue?vue&type=script&lang=js&"
export * from "./KnFormSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports